import { Subject } from "rxjs"
import { Point } from "../../models/Point"

const t = {
    utext: [],
    utext$: new Subject(),
    textPosition: Point.ORIGIN.clone(),

    translateX: 0,
    translateY: 0,
    scale: 1,

    mouseClick: false,

    isPanning: false,
    panStartPoint: Point.ORIGIN.clone(),

    fontSize: 36,
    fontName: 'gost_type_a',

    offset: 6,

    editId: null,
    editBoundary: false, /**эта переменная нужна чтобы отключить магниты
                            если указатель наведён на текст в режиме text */
    currentLetterIndex: null,

}

export { t }